export default {
	bind: function(el, binding, vnode) {
		vnode.context.$nextTick(() => {
			el.querySelector(".ivu-select-selection").click();
			el.querySelector(".ivu-select-input").focus();
		});
	}
};
